import * as React from "react";
import { Navigate } from "react-router-dom";

import { useFeature } from "./useFeature";

/**
 * Route guard for a capability the user's plan may not include.
 *
 * <p>Sends them to {@code /upgrade} rather than rendering a locked page, because a bookmarked or
 * hand-typed URL is not a moment to sell — they went somewhere specific and should land somewhere
 * that explains what they would get. {@code replace} keeps Back working: without it, going back
 * lands on the guarded route again and bounces straight forward.</p>
 *
 * <p>Renders nothing while the answer is in flight. A spinner would flash on every navigation for
 * the fraction of a second the entitlements call takes, and the shared promise means only the first
 * route pays for it at all.</p>
 *
 * <p><b>Not security.</b> Anyone can edit their own bundle. Every capability this guards is refused
 * server-side too; this only keeps the UI honest.</p>
 */
export function RequireFeature({
  feature,
  children,
}: {
  feature: string;
  children: React.ReactNode;
}) {
  const state = useFeature(feature);
  if (state === "loading") return null;
  if (state === "denied") return <Navigate to="/upgrade" replace />;
  return <>{children}</>;
}
